export default __webpack_public_path__ + "static/media/gallery05.19c7aa69.jpg";